<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div style="margin-left: 20px;margin: 20px;">
          <div style="font-size: 18px;margin-top: 20px;">为了给收入较低的老师尽一点绵薄之力,快查成绩即日起推出助教增收活动</div>
          <div style="font-size: 18px;margin-top: 20px;">
            具体要求如下：
          </div>
          <div style="font-size: 18px;margin-top: 20px;">
            1.在小红书上发布使用我们快查成绩、多人填表、万能快查、我的文件微信小程序任何一款笔记或视频的；
          </div>
          <div style="font-size: 18px;margin-top: 20px;">
            2.收藏量达到100+以上的即可奖励100元现金；收藏达到1000+以上的再补奖励100元.
          </div>
          <div style="font-size: 18px;margin-top: 20px;">
            3.收藏达标需要领取奖金的老师请加微信 wx34424698 .
          </div>
          <div style="font-size: 18px;margin-top: 20px;">
            4.活动自2023年3月17日凌晨开始计算,即这个时间点以后发布的笔记可以参加活动.
          </div>

          <div style="font-size: 18px;margin-top: 20px;">特别说明：由于我们资金有限,仅限前50位老师,且最多50位老师。</div>

          <div>
            <div style="font-size: 18px;margin-top: 20px;">四个小程序的如下,请扫码体验:</div>

            <div style="display: flex;justify-content: space-evenly;align-items: center;">
              <div>
                <div style="display: flex;flex-direction: column;">
                  <div
                    style="font-size: 18px;margin-top: 20px;text-align: center;color:red;">
                    快查成绩
                  </div>
                  <div><img src="/score/images/kccj_qrcode.jpg" style="width: 200px;height: 200px;" />
                  </div>
                </div>
              </div>
              <div>
                <div style="display: flex;flex-direction: column;">
                  <div
                    style="font-size: 18px;margin-top: 20px;text-align: center;color:red;">
                    多人填表
                  </div>
                  <div><img src="/score/images/drtb_qrcode.jpg" style="width: 200px;height: 200px;" />
                  </div>
                </div>
              </div>
              <div>
                <div style="display: flex;flex-direction: column;">
                  <div
                    style="font-size: 18px;margin-top: 20px;text-align: center;color:red;">
                    万能快查
                  </div>
                  <div><img src="/score/images/wnkc_qrcode.jpg" style="width: 200px;height: 200px;" />
                  </div>
                </div>
              </div>
              <div>
                <div style="display: flex;flex-direction: column;">
                  <div
                    style="font-size: 18px;margin-top: 20px;text-align: center;color:red;">
                    我的文件
                  </div>
                  <div><img src="/score/images/wdwj_qrcode.jpg" style="width: 200px;height: 200px;" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


      </el-col>
    </el-row>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  import '../assets/global.css'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {

      }
    },
    mounted() {

    },
    created() {

    },
    methods: {

    },
    watch: {

    }
  }
</script>

<style>
  .actionStyle {
    display: flex;
    flex-direction: column;

  }

  :header-cell-style: {
    background: '#E9EEF5';
    color: '#000'
  }

  .actionBarStyle {
    display: flex;
    justify-content: space-between;
  }

  .settingGroupStyle {
    display: flex;
    flex-direction: column;
  }

  .rowStyle {
    display: flex;
    justify-content: left;
    padding-left: 50upx;
  }

  .dateRowStyle {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .imgItemStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .imageStyle {
    display: flex;
    justify-content: center;

  }
</style>



// WEBPACK FOOTER //
// src/components/help_teacher_xhs.vue